import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getAllCurrenciesStart } from '../../../../store/redux-slices/currencies'
import { getLanguagesStart } from '../../../../store/redux-slices/languages'

const useTenant = ({ createTenantData }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { tenantId } = useParams()
  const { allCurrencies, loading } = useSelector((state) => state.currencies)
  const [currencies, setCurrencies] = useState([{ label: 'Euro', value: 'EUR' }])
  const [allowedLanguages, setAllowedLanguages] = useState([{ label: 'English', value: 'EN' }])
  const [allowedProviders, setAllowedProviders] = useState()
  const { tenantDetails } = useSelector((state) => state.tenants)
  const { languages } = useSelector(state => state.languages)
  const { casinoProvidersData } = useSelector((state) => state.superAdminCasino)

  useEffect(() => {
    !languages && dispatch(getLanguagesStart({ name: '', limit: '', pageNo: '' }))
  }, [])

  const currData =
    tenantId &&
    createTenantData.allowedCurrencies.map((currency) => {
      return (
        allCurrencies && allCurrencies?.rows.find((c) => c.code === currency)
      )
    })

  const language =
    tenantId && createTenantData.allowedLanguages.map((lang) => {
      return languages && languages?.rows.find((l) => l.code === lang)
    })

  const providers =
    tenantId && createTenantData?.providerIds?.map((p) => {
      return casinoProvidersData && casinoProvidersData?.rows.find((provider) => provider.casinoProviderId === p)
    })

  useEffect(() => {
    const tenantCurrencies = []
    if (allCurrencies &&
      tenantId) {
      currData.forEach(function (element) {
        tenantCurrencies.push({ label: element.name, value: element.code })
      })
      setCurrencies(tenantCurrencies)
    }
  }, [tenantId, allCurrencies, createTenantData?.allowedCurrencies])

  useEffect(() => {
    const langOpt = []
    if (languages && tenantId) {
      language.forEach(function (lang) {
        langOpt.push({ label: lang.languageName, value: lang.code })
      })
      setAllowedLanguages(langOpt)
    }
  }, [tenantId, languages, createTenantData?.allowedLanguages])

  useEffect(() => {
    const casinoProviders = []
    if (providers && tenantId) {
      providers.forEach(function (provider) {
        casinoProviders.push({ label: provider.name, value: provider.casinoProviderId })
      })
      setAllowedProviders(casinoProviders)
    }
  }, [tenantId, createTenantData?.tenantConfig?.gameProviders])

  const currOptions = []
  allCurrencies &&
    allCurrencies.rows.forEach(function (element) {
      currOptions.push({ label: element.name, value: element.code })
    })

  const langOptions = []
  languages &&
    languages.rows.forEach(function (language) {
      langOptions.push({ label: language.languageName, value: language.code })
    })

  const providerOptions = []
  casinoProvidersData &&
    casinoProvidersData.rows.forEach(function (provider) {
      providerOptions.push({ label: provider.name, value: provider.casinoProviderId })
    })

  useEffect(() => {
    dispatch(getAllCurrenciesStart({ limit: '', pageNo: '' }))
  }, [])

  if (!createTenantData.primaryCurrency) {
    createTenantData.primaryCurrency = createTenantData.allowedCurrencies[0]
  }

  return {
    tenantId,
    currencies,
    setCurrencies,
    currOptions,
    allCurrencies,
    navigate,
    loading,
    tenantDetails,
    languages,
    setAllowedLanguages,
    allowedLanguages,
    langOptions,
    allowedProviders,
    providerOptions,
    setAllowedProviders
  }
}

export default useTenant
